var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.399,
    height: 31.399,
    viewBox: "0 0 31.399 31.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-25.058 -999.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M7.925,10a3.925,3.925,0,1,0,3.925,3.925A3.936,3.936,0,0,0,7.925,10Zm23.549,0A3.925,3.925,0,1,0,35.4,13.925,3.936,3.936,0,0,0,31.474,10ZM19.7,10a3.925,3.925,0,1,0,3.925,3.925A3.936,3.936,0,0,0,19.7,10Z",
    transform: "translate(21.058 1000.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M7.925,10a3.925,3.925,0,1,0,3.925,3.925A3.936,3.936,0,0,0,7.925,10Zm23.549,0A3.925,3.925,0,1,0,35.4,13.925,3.936,3.936,0,0,0,31.474,10ZM19.7,10a3.925,3.925,0,1,0,3.925,3.925A3.936,3.936,0,0,0,19.7,10Z",
    transform: "translate(21.058 989.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M7.925,10a3.925,3.925,0,1,0,3.925,3.925A3.936,3.936,0,0,0,7.925,10Zm23.549,0A3.925,3.925,0,1,0,35.4,13.925,3.936,3.936,0,0,0,31.474,10ZM19.7,10a3.925,3.925,0,1,0,3.925,3.925A3.936,3.936,0,0,0,19.7,10Z",
    transform: "translate(21.058 1012.773)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.d7bcb0ac39eb15875559dc475ac4f627.svg";
export { ForwardRef as ReactComponent };